module.exports = __webpack_public_path__ + "static/media/look.ff1869e8.svg";